import React, { useEffect, useState } from 'react';
import { get } from "lodash";
// import { loadState } from '../../store/LocalStorage'
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from 'react-router-dom'

function UpdateCategory(props) {
    // const history=useHistory();
    const navigate = useHistory();
    const [Emotion, setEmotion] = React.useState('');    
    const [formData, setName] = useState({ category: "" });
    const CatId = localStorage.getItem('CategoryVal');
    // const { IntId, Ques} = get(loadState(), "IntId") || {};
    // //console.log("pass id", IntId)
    useEffect(() => {

        LoadCategory();

    }, [])

    const LoadCategory = () => {

        const datavalue = {
            id: CatId
        }
        // const config = {

        //     headers: { 'content-type': 'multipart/form-data' }
        // }
        var authOptions = {
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/getCategoryByid`,
            data: datavalue,
            headers: { 'Content-Type': 'multipart/form-data' },
        };
        axios(authOptions)
            // axios.post(`https://localhost:7261/getIntentsByid`, datavalue, config)
            .then(res => {
                //console.log("get value", res);
                //console.log("list", res.data.result[0].id)
                // setIntentList(res.data)
                setName({ category: res.data.result[0].Category});
               
            })
    }

    const updatesubmit = async (e) => {
        e.preventDefault();

        //console.log("formData", formData)

        let formDataSet = new FormData();
        //formdata object
        if (formData.intents === "") {
            if (formData.intents === "") {
                Swal.fire({
                    title: "Error",
                    text: "Question Field Is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            }
        } else {
            formDataSet.append('Category', formData.category);  //append the values with key, value pair
           
            formDataSet.append('id', CatId);

            // const config = {
            //     headers: { 'content-type': 'multipart/form-data' }
            // }
            var authOptions = {
                method: "post",
                url: `${process.env.REACT_APP_API_URL}/updateCategoryByid`,
                data: formDataSet,
                headers: { 'Content-Type': 'multipart/form-data' },
            };
            axios(authOptions)
                
                .then(res => {
                    //console.log("get value", res);

                    //console.log("success")
                    // setName({ intents: "", Ans1: "", Ans2: "" });
                    Swal.fire({
                        title: "Success",
                        text: "Intents Update Successfully",
                        icon: "success",
                        confirmButtonText: "Ok",
                    }).then(function () {
                        // window.location.pathname = "/patient-ai/IntentList";
                        // //console.log("not push")
                        // history.push('/IntentList');
                       
                        navigate.push('/CategoryList');
                    });

                })
                .catch(error => {
                    //console.log("error occur", error);
                })
        }

    }
    const BackFunc = () => {
        navigate.push('/CategoryList')
   }
  
    const handleChange = (e) => {
        setName({ ...formData, [e.target.name]: e.target.value });
    };
    return (
        <>
            <div className="page-content-wrapper">
                <div className="page-content">
                    <div className="page-bar">
                        <div className="page-title-breadcrumb">
                            {/* <div className=" pull-left">
                                <div className="page-title">Update Intent</div>
                            </div> */}
                            <div className=" pull-right">
                                <button type="submit" className="btn btn-primary d-inline-block" onClick={BackFunc}> <i className="fa fa-arrow-left" aria-hidden="true"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                    <div className="col-md-3 col-sm-3">
                        </div>
                        <div className="col-md-6 col-sm-6">
                        
                            <div className="card card-box">  
                            <div className="card-head">
                                    <header>Update Category</header>

                                </div>                            
                                <div className="card-body " id="bar-parent">
                                    <form className="register-form" id="login-form" onSubmit={updatesubmit}>
                                        <div className="form-group">
                                            <label for="simpleFormEmail" className="control-label">Question</label><i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red", padding: "4px" }} />
                                            <input type="text"
                                                value={formData.category}
                                                onChange={handleChange}
                                                name="category" className="form-control" id="simpleFormEmail"
                                                placeholder="Enter category" />
                                        </div>
                                       
                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3">
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UpdateCategory;